import { Form } from 'antd';
import styled from 'styled-components';

export const StyledItem = styled(Form.Item)`
  width: 100%;
`;
